import React from 'react';

import Data from 'data';
import Store from 'store';
import Locale from 'data/locale';
import { D3TooltipGem } from 'tooltips';
import { ItemIcon, SkillHeader, SkillActive, SkillInfo, SkillParams } from './skillInfo';
import { getStats } from 'logic/stats';

const _L = Locale("ui-skills.js");

export const GemCard = React.memo(function GemCard({ gem }) {
  const info = Data.legendaryGems[gem];

  const level = Store.useSelector(state => {
    const stats = getStats(state);
    return stats.gems[gem] || 0;
  }, [gem]);

  const hasBuffs = Store.useSelector(state => {
    const info = Data.legendaryGems[gem];
    if (info && info.check && typeof info.buffs === "function") {
      const stats = getStats(state);
      return !!info.buffs(stats.gems[gem] || 0, stats);
    } else {
      return true;
    }
  }, [gem]);

  if (!info) return null;

  let noParams = false;
  let showApply;
  if (info.check && typeof info.buffs === "function") {
    showApply = hasBuffs;
    noParams = !hasBuffs;
  } else {
    showApply = !!info.effects[0].stat;
    if (!showApply && level >= 25) {
      showApply = !!info.effects[1].stat;
    }
  }

  return (
    <div className="d3p-SkillCard d3p-gem">
      <D3TooltipGem id={gem} level={level}>
        <SkillHeader icon={<ItemIcon id={gem}/>}
                     name={<span>{info.name}{level > 0 && <span className="d3p-gem-rank"> &#x2013; {_L`Rank ${level}`}</span>}</span>}
        >
          <div className="d3p-passive-extra">
            {showApply && <SkillActive info={info}/>}
            {!!(!noParams && info.params) && <SkillParams info={info}/>}
            {!!info.info && <SkillInfo type="gem" id={gem}/>}
          </div>
        </SkillHeader>
      </D3TooltipGem>
    </div>
  );
});

export default function GemsSection() {
  const state = Store.useState();
  const stats = getStats(state);

  const gems = Object.keys(stats.gems);
  if (!gems.length) return null;

  return (
    <React.Fragment>
      <h3 className="d3p-skill-category">{_L`Legendary Gems`}</h3>
      {gems.map(gem => <GemCard key={gem} gem={gem}/>)}
    </React.Fragment>
  );
}
